// dataTargetsSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { targetsApi } from "./targetsApi";

const initialManualState = {
    status: "idle",
    hotelID: null,
    filtersKey: null,
    manualTargets: [],
    periodRows: [],
    manualTargetsCounts: [],
    periodCounts: [],
    targetsTree: {},
    error: null,
};

const initialState = {
    status: "idle",
    data: [],
    hotelID: null,
    error: null,
    manual: initialManualState,
};

const slice = createSlice({
    name: "dataTargets",
    initialState,
    reducers: {
        loading_Targets: (state, action) => {
            const { hotelID } = action.payload;
            state.status = "loading";
            state.hotelID = hotelID;
            state.error = null;
        },
        load_Targets: (state, action) => {
            const { data, hotelID } = action.payload;
            state.status = "loaded";
            state.data = data;
            state.hotelID = hotelID;
            state.error = null;
        },
        error_Targets: (state, action) => {
            const { hotelID, error } = action.payload;
            state.status = "error";
            state.hotelID = hotelID;
            state.error = error;
        },

        loading_ManualTargets: (state, action) => {
            const { hotelID, filtersKey } = action.payload;
            state.manual.status = "loading";
            state.manual.hotelID = hotelID;
            state.manual.filtersKey = filtersKey;
            state.manual.error = null;
        },
        load_ManualTargets: (state, action) => {
            const {
                hotelID,
                filtersKey,
                manualTargets,
                periodRows,
                manualTargetsCounts,
                periodCounts,
                targetsTree,
            } = action.payload;

            state.manual.status = "loaded";
            state.manual.hotelID = hotelID;
            state.manual.filtersKey = filtersKey;
            state.manual.manualTargets = manualTargets;
            state.manual.periodRows = periodRows;
            state.manual.manualTargetsCounts = manualTargetsCounts;
            state.manual.periodCounts = periodCounts;
            state.manual.targetsTree = targetsTree ?? {};
            state.manual.error = null;
        },
        error_ManualTargets: (state, action) => {
            const { hotelID, filtersKey, error } = action.payload;

            state.manual.status = "error";
            state.manual.hotelID = hotelID;
            state.manual.filtersKey = filtersKey;
            state.manual.manualTargets = [];
            state.manual.periodRows = [];
            state.manual.manualTargetsCounts = [];
            state.manual.periodCounts = [];
            state.manual.targetsTree = {};
            state.manual.error = error;
        },
        clear_ManualTargets: (state) => {
            state.manual = initialManualState;
        },
    },
    extraReducers: (builder) =>
        builder
            .addMatcher(targetsApi.endpoints.getTargets.matchPending, () => {
                // Manual control is kept in DataLoader
            })
            .addMatcher(targetsApi.endpoints.getTargets.matchFulfilled, () => {
                // Manual control is kept in DataLoader
            })
            .addMatcher(targetsApi.endpoints.getTargets.matchRejected, () => {
                // Manual control is kept in DataLoader
            }),
});

export default slice.reducer;

export const {
    loading_Targets,
    load_Targets,
    error_Targets,
    loading_ManualTargets,
    load_ManualTargets,
    error_ManualTargets,
    clear_ManualTargets,
} = slice.actions;
